/**
 * 按单人份加价率从高到低贪心；每道菜的成本和售价 = 单人份 × 人数。
 * 总售价不得超过总预算。
 */
export function selectDishes(dishes, context) {
  const maxPrice = Number(context.maxPrice != null ? context.maxPrice : context.totalBudget)
  const guestCount = Number(context.guestCount) || 1
  const sorted = (dishes || [])
    .slice()
    .sort((a, b) => {
      const ma = Number(a.cost) > 0 ? (Number(a.price) - Number(a.cost)) / Number(a.cost) : 0
      const mb = Number(b.cost) > 0 ? (Number(b.price) - Number(b.cost)) / Number(b.cost) : 0
      return mb - ma
    })

  const selected = []
  let usedPrice = 0

  sorted.forEach((dish) => {
    const lineCost = Number(dish.cost) * guestCount
    const linePrice = Number(dish.price) * guestCount
    if (usedPrice + linePrice <= maxPrice) {
      selected.push({
        ...dish,
        qty: guestCount,
        linePrice,
        lineCost
      })
      usedPrice += linePrice
    }
  })

  return selected
}
